import React, { FC, useEffect, useRef, useCallback } from 'react'
import cn from 'classnames'
import classes from '../../FilterSelect/FilterOptions.module.scss'
import { Option } from '../../FilterSelect/types'

interface TimeSelectOptionsProps {
  options: Option[]
  onSelect: (option: Option) => void
  onRequestClose?: () => void
  open?: boolean
  'data-testid': any
}

export const TimeSelectOptions: FC<TimeSelectOptionsProps> = ({
  options,
  onSelect,
  open = true,
  onRequestClose = () => {},
  'data-testid': dataTestId,
}) => {
  const inputRef = useRef<HTMLInputElement>(null)

  useEffect(() => {
    if (open) {
      inputRef?.current?.focus()
    }
  }, [inputRef, open])

  const handleGlobalClick = useCallback(
    (event: MouseEvent) => {
      onRequestClose()
    },
    [onRequestClose]
  )

  useEffect(() => {
    if (!open) {
      return
    }

    document.addEventListener('click', handleGlobalClick)
    return () => {
      document.removeEventListener('click', handleGlobalClick)
    }
  }, [open, handleGlobalClick])

  return (
    <div className={cn(classes.container, { [classes.open]: open })}>
      <div className={classes.items}>
        {options.map((option) => (
          <button
            type="button"
            key={option.value}
            className={`${classes.item} ${dataTestId}-button`}
            onClick={() => onSelect(option)}
          >
            {option.label}
          </button>
        ))}
      </div>
    </div>
  )
}
